import React from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
// import { hillAfbAtGlance } from "./data/hillAfbData";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  Text,
} from "recharts";
import {
  hillAfbAtGlance,
  workforceBreakdown,
  expenditureBreakdown,
  economicImpactBreakdown,
} from "./data/hillAfbData";
const CustomAxisTick = ({ x, y, payload }) => {
  return (
    <Text
      x={x}
      y={y}
      dy={16}
      width={75}
      textAnchor="middle"
      verticalAnchor="start"
      fill="#374151"
      fontSize={10}
      fontWeight={500}
    >
      {payload.value}
    </Text>
  );
};
const EconomicImpactChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={260}>
    <PieChart>
      <defs>
        <filter id="shadow-econom" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur" />
          <feOffset in="blur" dx="3" dy="3" result="offsetBlur" />
          <feFlood floodColor="rgba(0,0,0,0.4)" />
          <feComposite in2="offsetBlur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="grad-econom-0" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#ff5c5c" />
          <stop offset="95%" stopColor="#9e1c1c" />
        </linearGradient>
        <linearGradient id="grad-econom-1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#9d4edd" />
          <stop offset="95%" stopColor="#480ca8" />
        </linearGradient>
        <linearGradient id="grad-econom-2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#d1d5db" />
          <stop offset="95%" stopColor="#6b7280" />
        </linearGradient>
      </defs>
      <Pie
        data={data}
        dataKey="value"
        nameKey="name"
        innerRadius={60}
        outerRadius={95}
        paddingAngle={5}
        stroke="none"
        filter="url(#shadow-econom)"
      >
        {data.map((_, i) => (
          <Cell key={i} fill={`url(#grad-econom-${i % 3})`} />
        ))}
      </Pie>
      <Tooltip
        formatter={(v) => `$${v} Billion USD`}
        contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
      />
      <Legend wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }} />
    </PieChart>
  </ResponsiveContainer>
);
const ExpenditureChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={300}>
    <PieChart>
      <defs>
        <filter id="shadow-expend" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur" />
          <feOffset in="blur" dx="3" dy="3" result="offsetBlur" />
          <feFlood floodColor="rgba(0,0,0,0.4)" />
          <feComposite in2="offsetBlur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="grad-expend-0" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#38bdf8" />
          <stop offset="95%" stopColor="#0369a1" />
        </linearGradient>
        <linearGradient id="grad-expend-1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#34d399" />
          <stop offset="95%" stopColor="#059669" />
        </linearGradient>
        <linearGradient id="grad-expend-2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#fbbf24" />
          <stop offset="95%" stopColor="#b45309" />
        </linearGradient>
        <linearGradient id="grad-expend-3" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#f472b6" />
          <stop offset="95%" stopColor="#be185d" />
        </linearGradient>
      </defs>
      <Pie
        data={data}
        dataKey="value"
        nameKey="name"
        outerRadius={95}
        stroke="white"
        strokeWidth={2}
        filter="url(#shadow-expend)"
      >
        {data.map((_, i) => (
          <Cell key={i} fill={`url(#grad-expend-${i % 4})`} />
        ))}
      </Pie>
      <Tooltip
        formatter={(v) => `$${v} Million USD`}
        contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
      />
      <Legend wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }} />
    </PieChart>
  </ResponsiveContainer>
);

const WorkforceChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={320}>
    <BarChart data={data} margin={{ bottom: 40 }}>
      <defs>
        <filter id="shadow-work" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur" />
          <feOffset in="blur" dx="3" dy="3" result="offsetBlur" />
          <feFlood floodColor="rgba(0,0,0,0.4)" />
          <feComposite in2="offsetBlur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="grad-workforce" x1="0" y1="0" x2="1" y2="0">
          <stop offset="5%" stopColor="#6d99f1ff" />
          <stop offset="95%" stopColor="#0e2546ff" />
        </linearGradient>
      </defs>
      <XAxis
        dataKey="name"
        axisLine={{ stroke: '#9ca3af', strokeWidth: 1 }}
        tickLine={false}
        interval={0}
        tick={<CustomAxisTick />}
      />
      <YAxis
        axisLine={false}
        tickLine={false}
        tick={{ fill: '#9ca3af', fontSize: 12 }}
      />
      <Tooltip
        cursor={{ fill: 'transparent' }}
        formatter={(v) => `${v.toLocaleString()} Jobs`}
        contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
      />
      <Bar
        dataKey="value"
        fill="url(#grad-workforce)"
        radius={[6, 6, 0, 0]}
        filter="url(#shadow-work)"
      />
    </BarChart>
  </ResponsiveContainer>
);

const KpiCard = ({ label, value, unit, description, color }) => (
  <div className="rounded-xl border border-gray-100 p-4 text-center bg-white shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
    <div className={`text-2xl font-bold ${color || 'text-red-600'}`}>
      {value.toLocaleString()}
    </div>
    <div className="text-xs text-gray-500 mt-1">{unit}</div>
    <div className="text-sm font-medium text-gray-800 mt-2">
      {label}
    </div>
    <div className="text-xs text-gray-500 mt-1">
      {description}
    </div>
  </div>
);
const HillAFBEconomicImpact = () => {
  return (
    <div>
      <LandingSection
        data={{
          imageName: "aerospace.webp",
          title: "Hill Air Force Base — At a Glance",
          visible: "",
        }}
      />

      <div className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        {/* <section className="max-w-7xl mx-auto bg-white rounded-2xl shadow-sm p-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">
                        Hill Air Force Base — At a Glance
                    </h2>
                    <p className="text-base text-gray-500 mb-8 max-w-2xl">
                        Hill Air Force Base is an economic powerhouse for Utah. This dashboard highlights the base's economic footprint, workforce contribution, and critical role in national defense and the local economy.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
                        {hillAfbAtGlance.map((item, index) => (
                            <div
                                key={index}
                                className="border border-gray-100 bg-white rounded-xl p-6 text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                            >
                                <div className="text-3xl font-extrabold text-red-700 mb-2">
                                    {item.value}
                                </div>
                                <div className="text-sm font-semibold text-gray-800 uppercase tracking-wide mb-1">
                                    {item.label}
                                </div>
                                <div className="text-xs text-gray-500 font-medium">
                                    {item.subtext}
                                </div>
                            </div>
                        ))}
                    </div>
                </section> */}
        <section className="bg-white rounded-2xl p-6 space-y-10">

          <h2 className="text-3xl text-center font-semibold text-blue-900">
            Hill Air Force Base — Economic Impact Year 2024
          </h2>


          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
            {hillAfbAtGlance.map((item, i) => (
              <KpiCard key={i} {...item} />
            ))}
          </div>


          <div className="grid md:grid-cols-3 gap-8">

            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col items-center">
              <h3 className="font-bold text-gray-800 mb-4 text-center">
                Economic Impact Composition <br />
                <span className="text-sm font-normal text-gray-500">(Billion USD)</span>
              </h3>
              <div className="w-full">
                <EconomicImpactChart data={economicImpactBreakdown} />
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col items-center">
              <h3 className="font-bold text-gray-800 mb-4 text-center">
                Annual Expenditures <br />
                <span className="text-sm font-normal text-gray-500">(Million USD)</span>
              </h3>
              <div className="w-full">
                <ExpenditureChart data={expenditureBreakdown} />
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col items-center">
              <h3 className="font-bold text-gray-800 mb-4 text-center">
                Workforce Composition <br />
                <span className="text-sm font-normal text-gray-500">(Jobs)</span>
              </h3>
              <div className="w-full">
                <WorkforceChart data={workforceBreakdown} />
              </div>
            </div>

          </div>


          <div className="mt-8 text-center pt-4 border-t border-gray-100">
            <p className="text-sm text-gray-700 italic mb-4 px-4 max-w-3xl mx-auto">
              <span className="font-semibold">Note:</span> Total Economic Impact (TEI) figures for Hill AFB represent the combined value of annual federal payroll, expenditures, and the estimated value of jobs created within the local community.
            </p>
            <p className="text-sm text-gray-500 mb-2">Data Source:</p>
            <a
              href="https://nuea.org/2025/03/27/hill-air-force-base-generates-12-76-billion-in-economic-impact-in-2024/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800 underline hover:no-underline transition-all"
            >
              NUEA - Hill Air Force Base Generates $12.76 Billion in Economic Impact in 2024
            </a>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default HillAFBEconomicImpact;
